import { useDisplay } from "vuetify";
import TextSearch from "@/components/Common/TextSearch/TextSearch.vue";
import "./FilterTypeMenu.scss";

export default {
  name: "FilterTypeMenu",
  components: { TextSearch },
  props: ["items", "label", "search", "itemKey", "selectedItems"],
  data() {
    return {
      searchText: "",
      filterTypeMenu: false,
      textSearch: ""
    };
  },
  computed: {
    itemKeyComputed() {
      return this.itemKey || "_id";
    },
    selectedItemsComputed() {
      console.log(this.itemKey, this.selectedItems);
      return this.selectedItems || [];
    },
    searchComputed() {
      return this.search;
    },
    itemsComputed() {
      const mappedItems =
        this.items?.map(item => ({
          ...item,
          label: item.label || item.text || item.title || item.name
        })) || [];

      if (!this.searchText?.length) return mappedItems;

      const filtered = mappedItems.filter(item =>
        item.label.toLowerCase().includes(this.searchText.toLowerCase())
      );

      return filtered;
    },
    labelComputed() {
      return this.label;
    },
    mobile() {
      const { mobile } = useDisplay();
      return mobile;
    }
  },
  methods: {
    setFilterType(typeKey) {
      this.$emit("input", typeKey);
    },
    triggerSearch(value) {
      this.searchText = value;
    }
  }
};
